import { memo } from "react";
import { LoadingOverlay } from "@atlas-int/ui";

interface GraphLoadingProps {
  zIndex?: number;
}

export const graphLoadingElementId = "graph-loading-element";

const GraphLoading = memo(({ zIndex }: GraphLoadingProps) => (
  <LoadingOverlay visible={true} zIndex={zIndex} />
));

GraphLoading.displayName = "GraphLoading";

export default GraphLoading;
